// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"77a36569","108":"16af3663","160":"08dfb177","545":"6f4b50cc","733":"6c4a5665","860":"5c53f332","871":"03ce505e","891":"eb3ac685"}[chunkId] + ".css";
};